import useAuth from '~hooks/useAuth';
import useIsFirstRender from '~hooks/useIsFirstRender';
import { AuthPageOption, AuthPageConfig } from '~types/common';

function hasConfigObject(config?: AuthPageOption): config is AuthPageConfig {
  return Boolean(config) && typeof config !== 'boolean';
}

interface Props {
  config?: AuthPageOption;
}

export default function Auth({ config, children }: React.PropsWithChildren<Props>) {
  const redirect = hasConfigObject(config) ? config?.redirect : undefined;
  const { status } = useAuth({ required: true, redirect });
  const isFirstRender = useIsFirstRender();

  if (status !== 'authenticated' && hasConfigObject(config) && isFirstRender) {
    return <>{config.loading}</>;
  }

  return <>{children}</>;
}
